import { useCallback, useState } from 'react';

const TOKEN_KEY = 'contract_token';

export function useAuth() {
  const [token, setToken] = useState(localStorage.getItem(TOKEN_KEY));

  const login = useCallback((nextToken) => {
    localStorage.setItem(TOKEN_KEY, nextToken);
    setToken(nextToken);
  }, []);

  const logout = useCallback(() => {
    localStorage.removeItem(TOKEN_KEY);
    setToken(null);
  }, []);

  return { token, login, logout };
}
